webpackJsonp([107142165995225],{

/***/ 378:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Story":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Story---1-EGp","StoryItemTwo":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo---Fuyb8","StoryItemTwo__Left":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo__Left---24KWj","StoryItemTwo__Right":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---StoryItemTwo__Right---30XFC","Strokes":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes---32pt9","Strokes__Yellow":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes__Yellow---N8NVj","Strokes__Blue":"src-components-WhatAboutCollege-Testimonial----Testimonials-module---Strokes__Blue---1rR89"};

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _VimeoEmbed = __webpack_require__(117);
	
	var _VimeoEmbed2 = _interopRequireDefault(_VimeoEmbed);
	
	var _TestimonialsModule = __webpack_require__(378);
	
	var _TestimonialsModule2 = _interopRequireDefault(_TestimonialsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Testimonial = function Testimonial(props) {
	  return _react2.default.createElement(
	    'div',
	    { id: props.id, className: _TestimonialsModule2.default.Story, style: props.style },
	    _react2.default.createElement(
	      'div',
	      { className: _TestimonialsModule2.default.Story__Wrapper },
	      _react2.default.createElement(
	        'div',
	        { className: _TestimonialsModule2.default.StoryItem + ' ' + _TestimonialsModule2.default.StoryItemTwo },
	        _react2.default.createElement(
	          'div',
	          { className: _TestimonialsModule2.default.StoryItemTwo__Left },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('img', { className: 'profile-image', src: props.testimonials.profileImage.file.url, alt: props.testimonials.profileImage.title }),
	            _react2.default.createElement('h3', { dangerouslySetInnerHTML: { __html: props.testimonials.title } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _TestimonialsModule2.default.StoryItemTwo__Right },
	          _react2.default.createElement(
	            'p',
	            { className: 'animated' },
	            props.testimonials.quote
	          ),
	          props.testimonials.videoLink && _react2.default.createElement(_VimeoEmbed2.default, {
	            url: props.testimonials.videoLink,
	            poster: props.testimonials.videoPosterImage ? props.testimonials.videoPosterImage : '',
	            loop: false,
	            autoplay: false,
	            controls: true
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Testimonial;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(293);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _DINavigation = __webpack_require__(69);
	
	var _DINavigation2 = _interopRequireDefault(_DINavigation);
	
	var _Afterhero = __webpack_require__(292);
	
	var _Afterhero2 = _interopRequireDefault(_Afterhero);
	
	var _Button = __webpack_require__(15);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _Testimonial = __webpack_require__(345);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	}
	
	var serviceLanding = function (_Component) {
	    _inherits(serviceLanding, _Component);
	
	    function serviceLanding(props) {
	        _classCallCheck(this, serviceLanding);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            activeNav: '',
	            controller: null
	        };
	        _this.links = [{ name: 'Impact', reference: 'impact' }, { name: 'How to Donate', reference: 'how-to-donate' }, { name: 'Monthly Giving', reference: 'monthly-giving' }, { name: 'Legacy Giving', reference: 'legacy-giving' }, { name: 'Donor Community', reference: 'donor-community' }];
	        return _this;
	    }
	
	    serviceLanding.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        // ZAPIER ID'S
	        // Facebook = q2tpnj
	        // Google = q2t724
	        var impact = document.querySelector('#impact');
	        var howToDonate = document.querySelector('#how-to-donate');
	        var monthlyGiving = document.querySelector('#monthly-giving');
	        var legacyGiving = document.querySelector('#legacy-giving');
	        var donorCommunity = document.querySelector('#donor-community');
	        var offset = 420;
	
	        this.controller = new ScrollMagic.Controller();
	
	        this.setState({
	            controller: this.controller
	        });
	
	        setTimeout(function () {
	            return _this2.navSceneInit();
	        }, 450);
	        // this.navSceneInit()
	        window.addEventListener('scroll', function () {
	            var impactTrigger = impact.offsetTop - offset;
	            var howToDonateTrigger = howToDonate.offsetTop - offset;
	            var monthlyGivingTrigger = monthlyGiving.offsetTop - offset;
	            var legacyGivingTrigger = legacyGiving.offsetTop - offset;
	            var donorCommunityTrigger = donorCommunity.offsetTop - offset;
	
	            var doc = document.documentElement,
	                top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	
	            if (top > donorCommunityTrigger) {
	                _this2.state.activeNav != 'donor-community' ? _this2.setState({ activeNav: 'donor-community' }) : null;
	            } else if (top > legacyGivingTrigger) {
	                _this2.state.activeNav != 'legacy-giving' ? _this2.setState({ activeNav: 'legacy-giving' }) : null;
	            } else if (top > monthlyGivingTrigger) {
	                _this2.state.activeNav != 'monthly-giving' ? _this2.setState({ activeNav: 'monthly-giving' }) : null;
	            } else if (top > howToDonateTrigger) {
	                _this2.state.activeNav != 'how-to-donate' ? _this2.setState({ activeNav: 'how-to-donate' }) : null;
	            } else if (top > impactTrigger) {
	                _this2.state.activeNav != 'impact' ? _this2.setState({ activeNav: 'impact' }) : null;
	            } else {
	                _this2.state.activeNav != '' ? _this2.setState({ activeNav: '' }) : null;
	            }
	        });
	    };
	
	    serviceLanding.prototype.navSceneInit = function navSceneInit() {
	        var triggerHook = window.innerWidth > 1200 ? .3 - 207 / window.innerHeight : 65 / window.innerHeight;
	        this.navScene = new ScrollMagic.Scene({
	            triggerElement: this.refs.pageNav,
	            triggerHook: triggerHook
	        }).setPin(this.refs.pageNav.children[0]).addTo(this.controller);
	        // .addIndicators()
	    };
	
	    serviceLanding.prototype.render = function render() {
	        var _this3 = this;
	
	        var _props$data = this.props.data,
	            page = _props$data.page,
	            testimonial = _props$data.testimonial;
	
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-donate' },
	            _react2.default.createElement(_CustomHelmet2.default, null),
	            _react2.default.createElement(_Hero2.default, {
	                title: 'Launch the leaders the world needs now',
	                src: 'https://images.ctfassets.net/j91b9gwu8s3q/2EicFcrEFCcdN5dbaAnAkX/823e3883357046140a2a7ec1f6c849be/44587388751_0ee64741ca_k.jpg',
	                style: { zIndex: '2' },
	                'static': true,
	                className: 'hero-wrapper'
	            }),
	            _react2.default.createElement(
	                'div',
	                { id: 'DIPageNav', ref: 'pageNav' },
	                _react2.default.createElement(_DINavigation2.default, {
	                    activeNav: this.state.activeNav,
	                    callbackRef: function callbackRef(el) {
	                        return _this3.pagenav = el;
	                    },
	                    links: this.links,
	                    donate: true
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content', style: { position: 'relative' }, id: 'impact' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-block no-padding-top' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', offsetL: '3', offsetLTab: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'capper-small' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'h2' },
	                                'Talent is universal, opportunity is not.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Each year we recruit the most talented high school graduates from across the country and around the world. We invest in young people who represent our society\u2019s diversity, and use the formative transition between high school and college to ignite their purpose.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                'Access, inclusion, and equity are in our DNA. Our sliding scale tuition is unique among travel programs and leadership opportunities, and it allows us to include exceptional young people from all financial backgrounds.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                'To date, more than 80% of our Fellows have received some level of need-based financial aid, and more than 30% have received a full ride.  This unparalleled commitment is only possible because of generous contributions from a dedicated and growing network of donor partners.'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://donate.globalcitizenyear.org/give/190334/#!/donation/checkout', target: '_blank' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'button' },
	                                    'DONATE TODAY'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Testimonial2.default, {
	                testimonials: testimonial,
	                style: { paddingBottom: '0', zIndex: '10', position: 'relative' }
	            }),
	            _react2.default.createElement(
	                'div',
	                { className: 'content', style: { position: 'relative' }, id: 'how-to-donate' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-block no-padding-bottom' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', offsetL: '3', offsetLTab: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'capper-small' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'h2' },
	                                'How to Donate'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Global Citizen Year is a 501c3, non-profit, and all contributions are fully tax-deductible.'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Donate Online'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://donate.globalcitizenyear.org/give/190334/#!/donation/checkout', target: '_blank' },
	                                    'Click here to make an online donation'
	                                ),
	                                '. You can give a one-time gift or increase your impact by easily making a ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://donate.globalcitizenyear.org/campaign/global-citizen-year-monthly-giving/c242196', target: '_blank' },
	                                    'recurring monthly contribution'
	                                ),
	                                '.'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Donate by Mail'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Checks made payable to Global Citizen Year can be mailed to:',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://goo.gl/maps/wEc1gYzTtWKUWpS5A', target: '_blank' },
	                                    'Global Citizen Year',
	                                    _react2.default.createElement('br', null),
	                                    '1625 Clay Street, Suite 400',
	                                    _react2.default.createElement('br', null),
	                                    'Oakland, CA 94612'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Double Your Donation'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Many companies match donations made by its employees to Global Citizen Year. Ask to see if your company will match your gift. '
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Amazon Smile'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'To donate 0.5% of your purchase to Global Citizen Year:'
	                            ),
	                            _react2.default.createElement(
	                                'ol',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Visit ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: 'https://smile.amazon.com/', target: '_blank' },
	                                        'Smile.Amazon.com'
	                                    ),
	                                    '.'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Go to Your Account from the navigation at the top of your page.'
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    'Select the option to Change your Charity to Global Citizen Year.'
	                                )
	                            ),
	                            _react2.default.createElement('img', { src: '//images.ctfassets.net/j91b9gwu8s3q/1JyCkJ5XmPPs52s6RzDyxf/063c904defc951163400104142b848bb/17011381672_dd5de5470d_k__3_.jpg', alt: '' })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content', style: { position: 'relative' }, id: 'monthly-giving' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-block no-padding-bottom' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', offsetL: '3', offsetLTab: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'capper-small' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'h2' },
	                                'Monthly Giving'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'A Monthly Gift Expands Your Impact Even Further'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Recurring, monthly donations fuel our mission. We\u2019re building a community of passionate supporters who, together, are creating a ripple of impact beyond themselves. Contributions at any level make a meaningful impact.'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://donate.globalcitizenyear.org/campaign/global-citizen-year-monthly-giving/c242196', target: '_blank' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'button' },
	                                    'SET UP MONTHLY DONATION'
	                                )
	                            ),
	                            _react2.default.createElement('img', { src: '//images.ctfassets.net/j91b9gwu8s3q/1Ctmws57haQmQmagAEAamS/bf0ead445772072a81ec73aea3ba7c90/Ismahan__1_.jpg', alt: '', style: { 'marginTop': '45px' } })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content', style: { position: 'relative' }, id: 'legacy-giving' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-block no-padding-bottom' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', offsetL: '3', offsetLTab: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'capper-small' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'h2' },
	                                'LEGACY GIVING'
	                            ),
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Make Your Mark and Create a Legacy of Global Changemakers'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'By making a legacy gift, you can ensure that our next generation of leaders have the perspectives and skills they\u2019ll need to address our most intractable global challenges. Our planned giving options include retirement plan assets, life insurance policies, bequests, and trusts.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                'We can help you get started.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null),
	                                'Please contact Sophia Ozenbaugh at ',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'mailto:sophia@globalcitizenyear.org' },
	                                    'sophia@globalcitizenyear.org'
	                                ),
	                                ' to learn more.'
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:caitlin@globalcitizenyear.org' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'button' },
	                                    'LEARN ABOUT LEGACY GIVING'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'content', style: { position: 'relative' }, id: 'donor-community' },
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-wrapper capper' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', mobile: '12', offsetL: '3', offsetLTab: '0' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'h2' },
	                                'DONOR COMMUNITY'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'We are grateful for the individuals, corporations, and foundations that have spurred Global Citizen Year\u2019s growth and ensured the program remains accessible to emerging leaders from all socioeconomic backgrounds.'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3', 'data-reactid': '133' },
	                                'Champions'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-reactid': '134' },
	                                'Our Champions include individuals who have committed $1,000,000 or more in funding for Global Citizen Year.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small' },
	                                'Arnhold Foundation | Brent Martini Family Trust | Mackenzie Family Foundation | Shelby Cullom Davis Charitable Fund | William K. Bowes, Jr. Foundation'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3', 'data-reactid': '133' },
	                                'Patrons'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-reactid': '134' },
	                                'Our Patrons include individuals who have committed $500,000 or more in funding for Global Citizen Year.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small' },
	                                'Crystal & Chris Sacca | The David & Lucille Packard Foundation | John Gunn & Cynthia Fry Gunn | Lisa & John Pritzker Family Fund | Mary Obelnicki & Craig Silverstein | S.D. Bechtel, Jr. Foundation | The William & Flora Hewlett Foundation'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3', 'data-reactid': '133' },
	                                'Benefactors'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-reactid': '134' },
	                                'Our Benefactors include individuals who have committed $250,000 or more in funding for Global Citizen Year.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small' },
	                                'Bill Falik & Diana Cohen | Coatue Foundation | Draper Richards Kaplan Foundation | George Family Foundation | Maggie Kaplan | Nike Foundation | Peery Foundation | Raikes Foundation | Steve & Roberta Denning | Vaya Trusts'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3', 'data-reactid': '140' },
	                                'Leaders'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { 'data-reactid': '141' },
	                                'Our Leaders include individuals and institutions that have committed $100,000 or more in funding for Global Citizen Year.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small' },
	                                'Ann MacDougall & Jules Kaufman | Allison & Dan Rose | Enlight Foundation | Ford Foundation | Franklin & Catherine Johnson Foundation | Gail Britton & Peter Knight | George Lee | Greg & Marybeth Lernihan | San Francisco Jewish Community Federation & Endowment Fund | Smita Singh | Steven & Alexandra Cohen Foundation | Sylvan/Laureate Foundation | The Crotty Family Foundation | The Friend Family Foundation | Tim Brady'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section-group' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'h3' },
	                                'Partners'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Our Partners include individuals and institutions that have committed $10,000 or more in funding for Global Citizen Year.',
	                                _react2.default.createElement('br', null),
	                                _react2.default.createElement('br', null)
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small' },
	                                'Ainslie Foundation | Arthur M. Blank Family Foundation | Ashoka | Betsy & Peter Chung | Betty & Jack Schafer | Bill Kunnath | Bill Mayer | Bill Plapinger & Cassie Murray | Bill Sahlman | Bob Fischer | Carol Swig | Charles & Susan Harris | Chris Varelas | Christina Pehl & Mark Headley | Cissie Swig | CityBridge Foundation | Claude & Andrea Stern | Craig Herb | Debra Wetherby | Diane Boyer Jerhoff | Ellen & Bob Peck | Elliot Schrage & Juliet Whitcomb | Eric Bauer | Eric Hanson | FThree Foundation | Garrett & Mary Moran | George Scharffenberger | Ginger & Jack Graham | Harry Falik | Harvard Business School | Howard Stevenson | Hummingbird Foundation | Isaac & Madeline Stein | Jeffrey C. Walker | Joe Mandato | JPMorgan Chase | Judy Kaplan | Karen Chakmakian | Karen Wagner | Kelly Pope | Kelly & David Burke | Kit & Ron Gordon | Koogle Foundation | Koret Foundation | Leigh Teece | Lisa & Ciaran O\u2019Kelly | Lisa & Douglas Goldman Fund | Lisa & Matt Chanoff | Lizzie & Jonathan Tisch | Lorene Arey | Lynn Feintech | Mal Warwick | Mark & Becky Levin | Martin & Mary Boyer Foundation | Maryanne Cataldo | MCJ Amelior Foundation | Michelle Wilver | Mulago Foundation | Nancy Heinen | Nathan Brill | Orin Kramer | Palayam Foundation | Park Foundation | Pritzker Pucker Family Foundation | Regan Pritzker & Chris Olin | Richard & Priscilla Hunt | Robert S. Kaplan | Robert J. Sweeney | Rogers Family Foundation | Sakurako & William Fisher | Shelly London | Stace Lindsay & Lisa Ceremsak | Steve Malkenson | Sukey & Michael Novogratz | Syzygy Foundation | The Karsh Family Foundation | The Bengier Foundation | The Janeth Fund | Theodore & Frances Geballe | Three Baers Family Charitable Fund | Victoria Ransom | Warren McFarlan | Westly Foundation | Zach Clayton'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _Row2.default,
	                    { className: 'content-wrapper capper no-padding-top' },
	                    _react2.default.createElement(
	                        _Column2.default,
	                        { width: '8', tablet: '12', mobile: '12', offsetL: '3' },
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We\u2019d also like to thank the thousands of supporters who have made small but meaningful contributions to our annual Fellowship Fund.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_Apply2.default, {
	                title: 'support global citizen year',
	                buttonTitle: 'make a donation',
	                buttonUrl: 'https://donate.globalcitizenyear.org/give/190334/#!/donation/checkout',
	                style: { zIndex: '20' }
	            })
	        );
	    };
	
	    return serviceLanding;
	}(_react.Component);
	
	exports.default = serviceLanding;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-donate-js-f4a84227f6b90508c79c.js